import React, {useState} from 'react';
import {CreateUserRequest} from "../../compiled";
import {useCreateUserRpc} from "../../util/RpcHooks/CreateUserRpc";
import './JoinKensu.css'
import {findError} from "../../util/ErrorUtil";
import {useAuth0} from "@auth0/auth0-react";
import {ActionButton} from "../../util/UI/ActionButton";
import {Link} from 'react-router-dom';

/**
 * This is used in two places!! It's in the regular user onboarding through
 * the kensu website, and embedded into the booking flow in case someone
 * hasn't created an account yet.
 */
export const JoinKensu = () => {

  const {user} = useAuth0();

  const [givenName, setGivenName] = useState(user?.given_name);
  const [familyName, setFamilyName] = useState(user?.family_name);
  const [email, setEmail] = useState(user?.email);
  const [acceptedTerms, setAcceptedTerms] = useState<boolean>(false);

  const createUserRpc = useCreateUserRpc();

  const error = (fieldName: string) => {
    const e = findError(createUserRpc.errors, fieldName);
    return e ? <div className={'ErrorText'}>{e}</div> : undefined;
  }

  const sendRpc = () => {
    createUserRpc.send(new CreateUserRequest({
      familyName: familyName,
      givenName: givenName,
      contactEmail: email,
      acceptedTermsVersion: acceptedTerms ? "2025-09-10" : ''
    }));
  }

  return <div className={'JoinKensuSection'}>

    {/*<WelcomeToKensu onContinue={() => {}}/>*/}
    <h2>Welcome to Kensu!</h2>
    <div>We’re excited to join you on your wellness journey.
      To start, please create a log in and answer a few questions
      to help us customize your experience.
    </div>

    <div className={'HorizontalFlexBox Gap20'} style={{marginTop: 13}}>

      <div className={'JoinKensuInputBlock'}>
        <div style={{flex: 1, fontWeight: 'bold', textAlign: 'left'}}>First name</div>
        <input style={{flex: 1}}
               type={'text'} className={'JoinKensuTextInput'}
               placeholder={'First name'}
               value={givenName ?? ''}
               onChange={event => {
                 setGivenName(event.target.value);
               }}/>
        {error('givenName')}
      </div>

      <div className={'JoinKensuInputBlock'}>
        <div style={{flex: 1, fontWeight: 'bold', textAlign: 'left'}}>Last name</div>
        <input style={{flex: 1}}
               type={'text'} className={'JoinKensuTextInput'}
               placeholder={'Last name'}
               value={familyName ?? ''}
               onChange={event => {
                 setFamilyName(event.target.value);
               }}/>
        {error('familyName')}
      </div>

    </div>

    <div className={'JoinKensuInputBlock'}>
      <div style={{fontWeight: 'bold', textAlign: 'left'}}>Email address</div>
      <input style={{flex: 1}}
             type={'text'} className={'JoinKensuTextInput'}
             placeholder={'Email'}
             value={email ?? ''}
             onChange={event => {
               setEmail(event.target.value);
             }}/>
      {error('contactEmail')}
    </div>

    <div className={'JoinKensuInputBlock'}>
      <div style={{fontWeight: 'bold', textAlign: 'left'}}>Terms and conditions</div>

      <div style={{display: 'flex', gap: 5}}>
        <input type={"checkbox"} onChange={event => {
          setAcceptedTerms(event.target.checked);
        }}/>
        <div>I agree to the&nbsp; 
          <Link style={{textDecoration: 'underline'}} target={'_blank'} to={'/consumer_tos'}>Kensu Consumer Terms of Service</Link>,&nbsp;
          <Link style={{textDecoration: 'underline'}} target={'_blank'} to={'/privacy_policy'}>Privacy Policy</Link>, and&nbsp; 
          <Link style={{textDecoration: 'underline'}} target={'_blank'} to={'/cookies_policy'}>Cookies Policy</Link>.
        </div>
      </div>
      {error('acceptedTermsVersion')}

    </div>

    <div className={'JoinKensuInputBlock'} style={{marginBottom: 30}}>
      <ActionButton onClick={sendRpc} rpcState={createUserRpc.rpcState}>Join</ActionButton>
    </div>

    {/* if there are no per-field errors, show the generic error message */}
    {!createUserRpc.errors.length && createUserRpc.rpcState.state == 'error' &&
        <div className={'ErrorText'} style={{textAlign: 'left'}}>
          Error creating your account. Please try again later.</div>}

  </div>
};
